<template>
  <form action="">
    <div class="modal-card" style="width: auto;min-width:25rem">
      <header class="modal-card-head">
        <p class="modal-card-title">Neuen Server erstellen</p>
      </header>
      <section class="modal-card-body">
        <b-field label="Name">
          <b-input
            @blur="generateSubdomain"
            placeholder="Name"
            v-model="serverData.name"
            required
          >
          </b-input>
        </b-field>

        <b-field label="Leistung">
          <b-select
            expanded
            placeholder="Typ auswählen"
            v-model="serverData.tier"
          >
            <option
              v-for="serverType in Object.keys($store.state.pricing.tiers)"
              :key="'t' + serverType"
              :value="serverType"
              >Typ {{ serverType }} &ndash;
              {{ $store.state.pricing.tiers[serverType].gross | pricing }}/{{
                $store.state.pricing.tiers[serverType].price_per === "month"
                  ? "Monat"
                  : "Stunde"
              }}</option
            >
          </b-select>
        </b-field>

        <b-field label="Subdomain" v-if="!showCustomDomainField">
          <b-field>
            <b-input
              expanded
              placeholder="Subdomain"
              v-model="serverData.domain"
              @blur="checkSubdomain"
              :required="!showCustomDomainField"
              :disabled="isEditing"
              validation-message="Nur Buchstaben, Zahlen und '-' erlaubt"
              pattern="[a-zA-Z0-9\-]*"
            />
            <p class="control">
              <span class="button is-static">.confcloud.de</span>
            </p>
          </b-field>
        </b-field>
        <b-field label="Eigene Domain" v-else>
          <b-input
            v-model="serverData.domain"
            :required="showCustomDomainField"
            placeholder="Eigene Domain"
            :disabled="isEditing"
          >
          </b-input>
        </b-field>
        <b-field>
          <b-switch
            v-model="showCustomDomainField"
            @input="toggleCustomDomainField"
            v-if="!isEditing"
            >Eigene Domain verwenden</b-switch
          >
        </b-field>

        <b-collapse
          :open.sync="showAdvancedSettings"
          animation="slide"
          aria-id="contentIdForA11y1"
        >
          <b-button
            aria-controls="contentIdForA11y1"
            slot="trigger"
            slot-scope="props"
            type="is-text"
            size="is-small"
            rounded
            expanded
            :icon-left="!props.open ? 'plus' : 'minus'"
            >{{
              !props.open ? "Erweiterte" : "Weniger"
            }}
            Einstellungen</b-button
          >

          <b-field label="BBB Repository (optional)">
            <b-input
              placeholder="BBB Repository (optional)"
              v-model="serverData.bbbrepo"
              :disabled="isEditing"
            />
          </b-field>
        </b-collapse>
        <div class="buttons">
          <b-button
            type="is-danger"
            size="is-small"
            outlined
            icon-left="trash-alt"
            v-if="isEditing"
            @click="confirmDelete"
            style="margin-top:.75rem"
            >Server löschen</b-button
          >
          <!--<b-button
            type="is-primary"
            size="is-small"
            outlined
            icon-left="cloud-download-alt"
            v-if="isEditing"
            v-show="showAdvancedSettings"
            >Image exportieren</b-button
          >-->
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button @click="close">Abbrechen</b-button>
        <b-button type="is-success" @click="createServer" v-if="!isEditing"
          >Kostenpflichtig bestellen</b-button
        >
        <b-button type="is-success" @click="editServer" v-else
          >Einstellungen speichern</b-button
        >
      </footer>
    </div>
  </form>
</template>

<script>
import serversConfig from "../servers.config.js";

export default {
  name: "ServerEditor",
  props: {
    server: {
      type: Object,
      default: function() {
        return {
          name: "",
          domain: "",
          tier: null,
          bbbrepo: ""
        };
      }
    }
  },
  data() {
    return {
      serverData: JSON.parse(JSON.stringify(this.server)),
      showCustomDomainField: this.server?.domain.indexOf(".") !== -1,
      suggestSubdomain: true,
      showAdvancedSettings: false
    };
  },
  computed: {
    serversConfig: function() {
      return serversConfig;
    },
    isEditing: function() {
      return this.server.id;
    },
    suggestedSubdomain: function() {
      const a =
        "àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;";
      const b =
        "aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------";
      const p = new RegExp(a.split("").join("|"), "g");

      let name = this.serverData.name.toLowerCase();

      //TODO make name nicer
      name = name
        .replace("ä", "ae")
        .replace("ö", "oe")
        .replace("ü", "ue")
        .replace("ß", "ss")
        .replace(/\s+/g, "-") // Replace spaces with -
        .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
        .replace(/&/g, "-und-") // Replace & with 'und'
        .replace(/[^\w-]+/g, "") // Remove all non-word characters
        .replace(/--+/g, "-") // Replace multiple - with single -
        .replace(/^-+/, "") // Trim - from start of text
        .replace(/-+$/, "");

      return name.substr(0, 64);
    }
  },
  methods: {
    close: function() {
      this.$parent.close();
    },
    generateSubdomain: function() {
      if (!this.suggestSubdomain || this.isEditing) return false;

      this.serverData.domain = this.suggestedSubdomain;
    },
    checkSubdomain: function() {
      if (this.serverData.domain === "") {
        this.suggestSubdomain = true;
        this.generateSubdomain();
      }

      this.serverData.domain = this.serverData.domain.toLowerCase();

      this.suggestSubdomain =
        this.serverData.domain === this.suggestedSubdomain;
    },
    toggleCustomDomainField: function(value) {
      if (value) {
        this.suggestSubdomain = false;
        this.serverData.domain = "";
      } else {
        this.suggestSubdomain = true;
        this.generateSubdomain();
      }
    },
    createServer() {
      this.$store.state.api.servers
        .create({
          name: this.serverData.name,
          domain: this.serverData.domain,
          tier: this.serverData.tier
        })
        .then(response => {
          console.log(response);
          if (response.data.id) {
            this.close();
            if (this.serverData.domain.indexOf(".") !== -1)
              this.notifyCNAMEInfo(response.data.id);
            this.$buefy.toast.open("Server wird erstellt...");
            this.$emit("changed");
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    editServer() {
      let data = {};

      if (this.serverData.name !== this.server.name)
        data.name = this.serverData.name;
      if (this.serverData.domain !== this.server.domain)
        data.domain = this.serverData.domain;
      if (this.serverData.tier !== this.server.tier)
        data.tier = this.serverData.tier;

      this.$store.state.api.servers
        .update(this.server.id, data)
        .then(response => {
          console.log(response);
          if (response.data.id) {
            this.close();
            this.$buefy.toast.open("Einstellungen gespeichert");
            this.$emit("changed");
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    deleteServer() {
      this.$store.state.api.servers
        .delete(this.server.id)
        .then(response => {
          console.log(response);
          if (response.data === "Deleted Successfully") {
            this.close();
            this.$buefy.toast.open("Server wird gelöscht...");
            this.$emit("changed");
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    confirmDelete() {
      this.$buefy.dialog.confirm({
        title: "Server löschen",
        message: `Bist du sicher, dass du den Server <b>${this.serverData.name}</b> löschen möchtest? Alle Einstellungen und Daten auf dem Server werden sofort unwiderruflich gelöscht.`,
        confirmText: "Ja, Server löschen",
        cancelText: "Abbrechen",
        type: "is-danger",
        hasIcon: true,
        icon: "times-circle",
        iconPack: "fa",
        ariaRole: "alertdialog",
        ariaModal: true,
        onConfirm: this.deleteServer
      });
    },
    notifyCNAMEInfo(id) {
      this.$buefy.dialog.alert({
        title: "Eigene Domain hinzufügen",
        message: `Um deine eigene Domain zu aktivieren, richte bitte einen <i>CNAME-Eintrag</i> bei deinem <i>DNS-Anbieter</i> für <code>${
          this.serverData.domain
        }</code> ein:<hr><table class="table"><tbody><tr><th>Typ</th><td>CNAME</td></tr><tr><th>Hostname</th><td><code>${this.getDNSHostname(
          this.serverData.domain
        )}</code></td></tr><tr><th>Ziel</th><td><code>s${id}.servers.confcloud.de</code></td></tr></tbody></table>`,
        confirmText: "Okay",
        type: "is-success",
        ariaRole: "alertdialog",
        ariaModal: true
      });
    },
    getDNSHostname(fqdn) {
      let hn = fqdn.split(".");
      hn.pop();
      hn.pop();
      return hn.join(".");
    }
  }
};
</script>

<style scoped lang="scss">
.footer {
  padding: $footerVPadding 0;
  margin-top: $footerMarginTop;

  background: rgba(gray, 0.1);

  &__navigation {
    display: flex;
    align-items: center;

    @include container;

    &__static {
      margin-right: auto;
    }
    &__link {
      text-decoration: none;
      margin-left: 1rem;
      color: $text;
      font-weight: 400;

      &:hover,
      &:focus {
        color: $primary;
      }
    }
  }
}
</style>
